import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import cn from 'classnames';
import { CssSpreadType } from '../../utils/css-spread-type';
import { TranquiTheme } from '../App/theme';

interface BudgetCategoryTypeTitleProps {
  title: string;
  subtitle: string;
  className?: string;
  classNameTitle?:string;
  classNameSubTitle?: string;
}

const BudgetCategoryTypeTitle: React.FC<BudgetCategoryTypeTitleProps> = (props) => {
  const { title, subtitle, className, classNameTitle, classNameSubTitle } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <Box className={className}>
      <Typography className={cn(classes.subtitle, classNameSubTitle)}>{title}</Typography>
      <Typography className={cn(classes.title, classNameTitle)}>{subtitle}</Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  title: {
    ...theme.typography.h3,
    color: theme.palette.indigo.main,
    marginBottom: `${theme.spacing(2.2)}px`,
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '11ch',
    lineHeight: '1.3',
  },
  subtitle: {
    ...(theme.typography.capitalize as CssSpreadType),
    color: theme.palette.text5.main,
    textTransform: 'uppercase',
    textAlign: 'left',
    marginBottom: theme.spacing(1),
  },
}));

export default BudgetCategoryTypeTitle;
